import IMG3 from "../../assets/images/dashboard/Female Employee.svg";
import IMG5 from "../../assets/images/dashboard/Full time Employee.svg";
import IMG2 from "../../assets/images/dashboard/Male Employee.svg";
import IMG7 from "../../assets/images/dashboard/modules 1.svg";
import IMG4 from "../../assets/images/dashboard/New Onboard.svg";
import IMGOthers from "../../assets/images/dashboard/others.svg";
import IMG6 from "../../assets/images/dashboard/Provisional.svg";
import IMG9 from "../../assets/images/dashboard/Total Employee.svg";
import IMG1 from "../../assets/images/dashboard/totalEmployee.svg";
import { useGetEmployeeCartDataQuery } from "../../features/dashboard/dashboardApi";
import useError from "../../hooks/useError";
import HeaderTitle from "./HeaderTitle";
import TopBarCard from "./TopBarCard";

export default function EmployeeCards() {
  const { data, isError, error } = useGetEmployeeCartDataQuery({});
  useError(isError, error, "Get employee cart data fail");

  const dataList = data?.data;

  const topBarData = [
    {
      title: "Total Employee",
      count: dataList?.totalEmployees,
      img: IMG1,
      color: "#D7FFEB",
      link: "/admin/employees",
      query: "status=active",
    },
    {
      title: "Male Employee",
      count: dataList?.maleEmployees,
      img: IMG2,
      color: "#DEE1E5",
      link: "/admin/employees",
      query: "status=active&gender=Male",
    },
    {
      title: "Female Employee",
      count: dataList?.femaleEmployees,
      img: IMG3,
      color: "#FFDEEC",
      link: "/admin/employees",
      query: "status=active&gender=Female",
    },
    {
      title: "Other Employee",
      count: dataList?.otherEmployees,
      img: IMGOthers,
      color: "#FFF5E4",
      link: "/admin/employees",
      query: "status=active&gender=Other",
    },
    {
      title: "Full Time",
      count: dataList?.fullTimeEmployees,
      img: IMG5,
      color: "#F0F3F7",
      link: "/admin/employees",
      query: "status=active&employee_type=permanent",
    },
    {
      title: "Provisional",
      count: dataList?.probationEmployees,
      img: IMG6,
      color: "#FFF2C4",
      link: "/admin/employees",
      query: "status=active&employee_type=on_probation",
    },
    {
      title: "Contractual",
      count: dataList?.contractEmployees,
      img: IMG7,
      color: "#E8EDFF",
      link: "/admin/employees",
      query: "status=active&employee_type=contractual",
    },
    {
      title: "New Onboard",
      count: dataList?.onboardedEmployees,
      img: IMG4,
      color: "#E4F4FF",
      link: "/admin/employees",
      query: "status=active&dashboard=on_boarding",
    },
    {
      title: "Intern",
      count: dataList?.internEmployees,
      img: IMG9,
      color: "#FFF5F4",
      link: "/admin/employees",
      query: "status=active&employee_type=intern",
    },
  ];

  return (
    <div>
      <HeaderTitle title="Employee" />

      <div className="grid md:grid-cols-4 sm:grid-cols-2 gap-6">
        {topBarData.map((item) => (
          <TopBarCard {...item} count={item.count || 0} key={item.title} />
        ))}
      </div>
    </div>
  );
}
